export default {
  type: "users",
  firstname: null,
  lastname: null,
  email: null,
  phone: null,
  is_staff: false,
  locale: null,
  password: null,
  password_confirmation: null,
  profile_image: null,
  relationshipNames: ["organization", "reseller", "roles"],
  roles: [
    {
      type: "roles",
      id: null,
    },
  ],
  organization: {
    type: "organizations",
    id: null,
  },
  reseller: {
    type: "resellers",
    id: null,
  },
};
